module.exports = __webpack_public_path__ + "img/thank_you_page.2984ae67.png";